<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">按筛选充值</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 10px;">

        <div>
          <div style="float:right;">

            <el-select size="mini" v-model="elderlyClassCode" placeholder="请选择老人类别"
                       style="width:150px;margin-right: 10px;" clearable>
              <el-option v-for="item in elderlyClassList"
                         :key="item.elderlyClassCode"
                         :label="item.name+'('+item.addBalance+')'"
                         :value="item.elderlyClassCode"></el-option>
            </el-select>

            <elSelectTree id="mySelectTree" :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                          placeholder="请选择所属区域"
                          v-on:getZoneValue="getZoneValue"
                          v-on:getZoneTitle="getZoneTitle"
                          :value='zoneCode'
                          style="width:140px;margin-right:10px;"></elSelectTree>

            <el-button size="mini" type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
          </div>
          <div style="clear:both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <el-table class="table" size="mini" :data="tableData" @selection-change="handleSelectionChange"
                  border :height="250">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="姓名" prop="name" width="100"></el-table-column>
          <el-table-column label="手机号" prop="phone"></el-table-column>
          <el-table-column label="身份证号" prop="idCard"></el-table-column>
          <el-table-column label="分类" prop="elderlyClassName"></el-table-column>
          <el-table-column label="区域" prop="zoneName"></el-table-column>
        </el-table>

      </div>
      <div class="modal-footer">
        <el-button type="primary" @click="confirm('addForm')">批量充值</el-button>
      </div>

    </div>


    <AddMulSelectConfirm ref="myAddMulSelectConfirm" v-show="showModalBatch"
                   v-on:closeAddMulSelectConfirm="showModalBatch=false"
                   v-on:closeAndList="closeAndList"></AddMulSelectConfirm>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import elSelectTree from "@/components/ElSelectTree";

import AddMulSelectConfirm from "./AddMulSelectConfirm";


export default {
  name: 'Elderly',
  data() {
    return {

      loading: false,

      showModalBatch:false,
      addBalance:0,


      elderlyClassList: [],
      elderlyClassCode:'',

      zoneValue:[],
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },
      zoneCode:'',
      zoneTitle:'',


      tableData:[],
      totalItems:0,
      pageSize: 2000,
      currentPage: 1,

      multipleSelection:[],

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components: {
    elSelectTree,AddMulSelectConfirm
  },
  methods: {
    init(){

      this.elderlyClassCode = '';
      this.zoneValue = [];
      this.zoneCode = '';
      this.zoneTitle = '';

      this.getElderlyClassList();
      this.getZoneList();

      this.getElderly();

    },
    closeSelf() {
      this.$emit("closeAddMulSelect");
    },
    closeAndList(){
      this.$emit("closeAddMulSelect");
      this.$emit("getList");
    },



    getElderlyClassList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.elderlyClassList = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getZoneList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {

        if (response.data.error === 0) {

          var data = JSON.stringify(response.data.data);

          //把空数组删除
          data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))

          this.zoneValue = data;

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      })
    },

    getZoneValue(val) {
      this.zoneCode = val
    },
    getZoneTitle(val){
      this.zoneTitle = val;
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderly();
    },
    getElderly(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/GovPageClassZone",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyClassCode:this.elderlyClassCode,
          zoneCode:this.zoneCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirm(){

      let classValue = 0;
      //let className = '';
      for(let i=0;i<this.elderlyClassList.length;i++){
        if(this.elderlyClassList[i].elderlyClassCode == this.elderlyClassCode){
          classValue = this.elderlyClassList[i].addBalance;
          //className = this.elderlyClassList[i].name;
        }
      }

      var list = this.multipleSelection
      if(this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择老人'});
      }
      else {
        for(var i in list) {
          list[i] = list[i].elderlyCode;
        }
      }
      console.log(list);

      this.showModalBatch = !this.showModalBatch;
      this.$refs.myAddMulSelectConfirm.init(classValue,list);
    },



  }
}


</script>

<style lang="scss" scoped>

/deep/ #mySelectTree .el-input__inner{
  height: 28px;
  font-size: 12px;
}
/deep/ #mySelectTree span.el-input__suffix-inner i.el-input__icon {
  line-height: 20px;
}

</style>
